import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RaisedButton, CircularProgress } from 'material-ui';
import { isInvalid, submit, isSubmitting } from 'redux-form';

const SubmitButton = ({ submit, submitting, form, ...props }) => (
    <RaisedButton
        {...props}
        disabled={submitting}
        icon={submitting ? <CircularProgress size={20} thickness={2.5} /> : undefined}
        onTouchTap={() => submit(form)}
    />
);

SubmitButton.propTypes = {
    form: PropTypes.string.isRequired
};

export default connect(
    (state, { form }) => ({
        disabled: isInvalid(form)(state),
        submitting: isSubmitting(form)(state)
    }),
    dispatch => ({ submit: form => dispatch(submit(form)) })
)(SubmitButton);



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/components/SubmitButton.js
 **/